module.exports = __webpack_public_path__ + "img/company1.45b286f.45b286fa.png";